import { Tabs as MuiTabs, styled } from "@mui/material"

const TAB_HEIGHT_IN_PX = 56
const INDICATOR_HEIGHT_IN_PX = 20
const INDICATOR_WIDTH_IN_PX = 4
const SELECTED_LABEL_GAP_IN_PX = 9

/** Vertical only: `SideNav` is the sole consumer and sets the orientation */
export const SideNavTabs = styled(MuiTabs)(({ theme: { spacing, palette } }) => ({
  "& .MuiTabs-flexContainerVertical": {
    display: "flex",
    gap: 0,
    flexDirection: "column",
    justifySelf: "start",
    width: "100%",
    "& .MuiTab-root": {
      minHeight: `${TAB_HEIGHT_IN_PX}px`,
      flexBasis: "100%",
      alignItems: "flex-start",
      textAlign: "left",
      paddingLeft: spacing(2),
      "&:not(:first-of-type)": {
        borderTop: `solid 1px ${palette.grey.extraLight}`,
      },
      "&.Mui-selected": {
        paddingLeft: `calc(${spacing(2)} + ${
          INDICATOR_WIDTH_IN_PX + SELECTED_LABEL_GAP_IN_PX
        }px)`,
      },
    },
  },
  "& .MuiTabs-indicator": {
    minWidth: `${INDICATOR_WIDTH_IN_PX}px`,
    height: `${INDICATOR_HEIGHT_IN_PX}px!important`,
    marginTop: `${(TAB_HEIGHT_IN_PX - INDICATOR_HEIGHT_IN_PX) / 2}px`,
  },
}))
